/** report statuses */
export const UNKNOWN = "unknown"
export const INITIALISED = "initialised"
export const QUEUED = "queued"
export const GENERATING = "generating"
export const FAILED = "failed"
export const COMPLETE = "complete"

export const ALL_STATUSES = [UNKNOWN, INITIALISED, QUEUED, GENERATING, FAILED, COMPLETE]
export const IN_PROGRESS_STATUSES = [UNKNOWN, INITIALISED, QUEUED, GENERATING]
export const FINISHED_STATUSES = [FAILED, COMPLETE]
